// extracted by mini-css-extract-plugin
export var bubble = "_3k-0";
export var container = "_3k-3";
export var contrastBorder = "_3k-4";
export var greyOut = "_3k-2";
export var initialsWrapper = "_3k-1";
export var large = "_3k-9";
export var medium = "_3k-8";
export var mediumSmall = "_3k-7";
export var mediumSmallMedium = "_3k-c";
export var micro = "_3k-5";
export var small = "_3k-6";
export var tiny = "_3k-b";
export var xTiny = "_3k-a";